import React from "react";
import { connect } from "react-redux";
import {
  Jibber,
  Flex,
  ToogleSwitch,
  NumberInput,
  TextInput,
  SVGButton,
  Hint,
} from "/app/src/component";
import OnlineForms from "./_OnlineFormular";
import GDPRRequirement from "./_GDPRRequirement";
import { ButtonBarLayout } from "/app/src/layoutComponent";
import CustomizationModel from "/app/src/model/Customization/model";
import style from "./style.css";

class OfflineSettings extends Jibber {
  constructor(props) {
    super(props);
    this.useState({
      autoresponseRequire: props.customization["autoresponse_require"],
      autoresponseConfig: props.customization["autoresponse_config"],
      formsRequire: props.customization["forms_require"],
      formsConfig: props.customization["forms_config"],
      gdprRequire: props.customization["gdpr_require"],
    });
    this._renderAutoresponse = this._renderAutoresponse.bind(this);
    this._renderFormular = this._renderFormular.bind(this);
    this.__renderForm = this.__renderForm.bind(this);
    this.__handleOnChangeTime = this.__handleOnChangeTime.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customization !== this.props.customization) {
      this.setState({
        autoresponseRequire: this.props.customization["autoresponse_require"],
        autoresponseConfig: this.props.customization["autoresponse_config"],
        formsRequire: this.props.customization["forms_require"],
        formsConfig: this.props.customization["forms_config"],
        changed: false,
      });
    }
  }
  _renderAutoresponse() {
    let time = this.state.autoresponseConfig.time;
    const toogleSwitch = {
      on: this.state.autoresponseRequire,
      manual: true,
      onChange: () => {
        this.setAutoresponseRequire(!this.state.autoresponseRequire);
      },
    };
    const label = {
      color: "black",
      fontSize: "24px",
      fontWeight: "300",
      my: "5px",
    };
    const labelHint = {
      style: { marginTop: "7px", marginLeft: "10px" },
      position: "top",
      tooltip:
        "När besökaren inte fått svar inom en viss tid så dyker ett e-postformulär upp i chatten. Besökaren kan då lämna sin e-postadress om hen inte vill vänta på svar i chatten och ni kan återkomma via mejl istället.",
    };

    return (
      <Flex w="100%" shrink={0}>
        <Flex basis="20%" pt="40px">
          <ToogleSwitch {...toogleSwitch} />
        </Flex>
        <Flex basis="80%" column>
          <Flex {...label}>
            {" "}
            Autorespons med e-postformulär <Hint {...labelHint} />{" "}
          </Flex>

          <Flex color="black" fontSize="18px" my="5px" column>
            Ange när e-postformuläret visas upp för besökaren.
          </Flex>
          <Flex color="black" fontSize="24px" fontWeight="300" my="10px">
            Skickas efter{" "}
            <NumberInput
              value={time}
              min={0}
              w="70px"
              mx="8px"
              fontSize="20px"
              onChange={this.__handleOnChangeTime}
            />{" "}
            sekunder.
          </Flex>
        </Flex>
      </Flex>
    );
  }

  __handleOnChangeTime(event) {
    const targetValue = event.target.value;
    //const time = this.state.autoresponseConfig.time;
    //Cant be less then 0.
    if (targetValue < 0) return;
    this.setAutoresponseConfig({ time: targetValue });
  }
  __renderForm(placeholder, name) {
    let visible = this.state.formsConfig[name]["visible"];
    let required = this.state.formsConfig[name]["require"];
    let visibleSrc = "/images/Hidden.svg";
    let requiredSrc = "/images/Require.svg";
    let colorVisible = "lightgrey";
    let colorRequired = "lightgrey";
    let inputClass = style.UnselectableText;
    if (visible) {
      visibleSrc = "/images/Visible.svg";
      colorVisible = "blue";
      inputClass = style.UnselectableTextVisible;
    }

    if (required) {
      requiredSrc = "/images/Require_Confirmed.svg";
      if (visible) {
        colorRequired = "blue";
      }
    }

    return (
      <Flex width="100%">
        <TextInput
          className={inputClass}
          my="5px"
          placeholder={placeholder}
          disabled
          width="70% !important"
        />
        <Flex position="relative">
          <SVGButton
            src={visibleSrc}
            color={colorVisible}
            width="50px"
            onClick={() => this.handleClick(name, "visible")}
          />
        </Flex>
        <Flex position="relative">
          <SVGButton
            src={requiredSrc}
            color={colorRequired}
            width="50px"
            onClick={() => this.handleClick(name, "require")}
          />
        </Flex>
      </Flex>
    );
  }
  handleClick(name, type) {
    console.log("handleclick")
    let temp = { ...this.state.formsConfig };
    temp[name][type] = !temp[name][type];
    console.log("name", name, "type", type, "temp", temp);
    if (this.state.formsRequire) {
      let sum = 0;
      for (var detail in temp) {
        console.log("detail in temp", detail);
        if (temp[detail]["visible"]) {
          sum += 1;
        }

      }
      if (sum === 0) {
        this.setFormsRequire(true);
        this.setFormsConfig(temp);
      }
    } else {
      for (var details in temp) {
        if (temp[details]["visible"]) {
          console.log("setting form again?")
          this.setFormsConfig(temp);
          return;
        }
      }
    }
    this.setFormsConfig(temp);
  }
  _renderFormular() {
    return (
      <Flex w="100%" mb="20px" mt="30px" shrink={0}>
        <Flex basis="20%" mt="25px">
          <ToogleSwitch
            on={this.state.formsRequire}
            manual
            onChange={(event) => {
              if (!this.state.formsRequire) {
                let sum = 0;
                let temp = { ...this.state.formsConfig };
                for (var detail in temp) {
                  if (temp[detail]["visible"]) {
                    sum += 1;
                  } else {
                    temp[detail]["visible"] = true;
                  }
                }
                if (sum === 0) {
                  this.setFormsConfig(temp);
                }
              }
              this.setFormsRequire(!this.state.formsRequire);
            }}
          />
        </Flex>
        <Flex basis="80%" column>
          <Flex color="black" fontSize="24px" fontWeight="300" my="5px">
            Kräv uppgifter innan påbörjad chatt
            <Hint
              style={{ marginTop: "7px", marginLeft: "10px" }}
              position="top"
              tooltip="Kräv att besökarna fyller i vissa uppgifter innan de kan börja skriva i chatten."
            />
          </Flex>
          <Flex color="#404040" fontSize="18px" my="5px" mb="40px">
            Välj nedan vilka uppgifter ni vill be om.
          </Flex>
          <OnlineForms
            formsConfig={this.state.formsConfig}
            setFormsConfig={this.setFormsConfig}
          />
        </Flex>
      </Flex>
    );
  }

  render() {
    if (!this.props.customization) return "";
    const ClientChatSettingsFormularContainerStyle = {
      dataName: "ClientSettingsFormularContainer",
      grow: true,
      width: "100%",
      column: true,
      hAlignContent: "center",
    };

    const FormularSaveButtonStyle = {
      dataName: "FormularSaveButton",
      color: "black",
      hover: "blue",
      border: true,
    };
    const FormularSaveButtonProps = {
      src: "/images/Save.svg",
      text: "Spara",
      disabled: !this.state.changed,
      onClick: () => {
        this.props.updateFormular({
          autoresponse_require: this.state.autoresponseRequire,
          autoresponse_config: this.state.autoresponseConfig,
          forms_require: this.state.formsRequire,
          forms_config: this.state.formsConfig,
          gdpr_require: this.state.gdprRequire,
        });
      },
    };
    return (
      <Flex {...ClientChatSettingsFormularContainerStyle}>
        <ButtonBarLayout>
          <Flex my="30px" column>
            <SVGButton
              {...FormularSaveButtonStyle}
              {...FormularSaveButtonProps}
            />
            <Flex
              h="10px"
              fontSize="12px"
              fontWeight="400"
              color="darkgrey"
              mt="2px"
            >
              {this.state.changed && "*Ändringar är inte sparade"}
            </Flex>
          </Flex>
        </ButtonBarLayout>

        <Flex hAlignContent="center" w="100%" h="100%" overflowY="auto">
          <Flex w="70%" column>
            <GDPRRequirement
              gdprRequire={this.state.gdprRequire}
              setGdprRequire={this.setGdprRequire}
            />
            <Flex w="100%" color="lightgrey" border="1px solid" my="10px" />
            {this._renderAutoresponse()}
            <Flex w="100%" color="lightgrey" border="1px solid" my="10px" />
            {this._renderFormular()}
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

const { selector: updatesSelector, dispatcher: updatesRequest } =
  CustomizationModel.updates();

const mapDispatchToProps = (dispatch, props) => ({
  updateFormular: (updates) => dispatch(updatesRequest(updates)),
});

const mapStateToProps = (state, props) => ({
  customization: updatesSelector.customization(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfflineSettings);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Formular/index.js